import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { getDeviceContextFromNodeEdgeMapper, NodeEdgeMapper } from '@iotv/datamodel-core';
import NodeEdgeMapperListTable from '../../common/NodeEdgeMapperListTable';
const debug = process.env.REACT_APP_DEBUG && false;
const LinksTab = ({ device, nodeEdgeMapper, deviceEnabledTypeIds }) => {
    debug && console.log('LinksTab', device, nodeEdgeMapper?.getSummary(), deviceEnabledTypeIds);
    let deviceContext = undefined;
    if (nodeEdgeMapper && deviceEnabledTypeIds)
        deviceContext = getDeviceContextFromNodeEdgeMapper({ nodeEdgeMapper, device, deviceEnabledTypeIds });
    if (!deviceContext)
        return _jsx(_Fragment, {});
    const { applicationServer, customer, group, entity, property, place } = deviceContext;
    const mapper = new NodeEdgeMapper();
    if (applicationServer)
        mapper.loadItem(applicationServer);
    if (customer)
        mapper.loadItem(customer);
    if (group)
        mapper.loadItem(group);
    if (entity)
        mapper.loadItem(entity);
    if (property)
        mapper.loadItem(property);
    if (place)
        mapper.loadItem(place);
    return nodeEdgeMapper ? _jsx(NodeEdgeMapperListTable, { mapper: mapper }) : _jsx(_Fragment, {});
};
export default LinksTab;
